import { render, staticRenderFns } from "./whatIsEin.vue?vue&type=template&id=2a946eed&scoped=true"
import script from "./whatIsEin.vue?vue&type=script&lang=js"
export * from "./whatIsEin.vue?vue&type=script&lang=js"
import style0 from "./whatIsEin.vue?vue&type=style&index=0&id=2a946eed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a946eed",
  null
  
)

export default component.exports